import { useSelector } from 'react-redux';

import { rolesSelector } from './selectors';

export function useGetRoles() {
  return useSelector(rolesSelector);
}
